export async function sendVerificationSms(phone: string): Promise<{ success: boolean; error?: string }> {
    const phoneWithCountry = phone.startsWith('+55') ? phone : `+55${phone.replace(/\D/g, '')}`;
    try {
        const response = await fetch('/api/sms', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ phone: phoneWithCountry })
        });
        return await response.json();
    } catch (error) {
        return { success: false, error: 'Erro ao enviar código de verificação' };
    }
}

// Função sendContract removida - todo o processo agora é feito pelo backend Laravel
// através do endpoint /api/partner-registration